import { Dictionary } from '@wuic-core/types';

/**
 * Avaliable icon size variations
 */
export enum WefoxIconSizeEnum {
  'small' = 'small',
  'default' = 'default',
  'medium' = 'medium',
  'large' = 'large',
}

/**
 * Internal component class mappings
 */
export const WefoxIconSizeClassMap: Dictionary<string> = {
  small: 'icon-sm',
  medium: 'icon-md',
  large: 'icon-lg',
  default: '',
};
